import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import { withTranslation } from 'react-i18next';

var OutlineItem = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(OutlineItem, _React$PureComponent);

  var _super = _createSuper(OutlineItem);

  function OutlineItem() {
    var _this;

    _classCallCheck(this, OutlineItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.onClick = function (event) {
      _this.props.editor.scrollToNode(_this.props.node);
    };

    return _this;
  }

  _createClass(OutlineItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var hash = decodeURI(window.location.hash);
      hash = hash.substring(1, hash.length);

      if (hash && this.props.node && hash === this.props.node.text) {
        this.props.editor && this.props.editor.scrollToNode(this.props.node);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          node = _this$props.node,
          index = _this$props.index,
          activeTitleIndex = _this$props.activeTitleIndex;
      var className = "".concat(node.type === 'header_two' ? 'outline-h2' : '', "\n      ").concat(node.type === 'header_three' ? 'outline-h3' : '', "\n      ").concat(index === activeTitleIndex ? ' active' : '');
      return /*#__PURE__*/React.createElement("div", {
        className: className,
        key: index,
        onClick: this.onClick
      }, node.children[0].text);
    }
  }]);

  return OutlineItem;
}(React.PureComponent);

var OutlineView = /*#__PURE__*/function (_React$PureComponent2) {
  _inherits(OutlineView, _React$PureComponent2);

  var _super2 = _createSuper(OutlineView);

  function OutlineView(props) {
    var _this2;

    _classCallCheck(this, OutlineView);

    _this2 = _super2.call(this, props);

    _this2.getHeaderList = function (document) {
      var headerList = [];
      document.forEach(function (node, index) {
        if (node.type === 'header_two' || node.type === 'header_three') {
          headerList.push(Object.assign({}, node, {
            path: [index]
          }));
        }
      });

      _this2.setState({
        headerList: headerList
      });
    };

    _this2.state = {
      headerList: null
    };
    return _this2;
  }

  _createClass(OutlineView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getHeaderList(this.props.document);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.document !== nextProps.document) {
        this.getHeaderList(nextProps.document);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var headerList = this.state.headerList;
      return /*#__PURE__*/React.createElement("div", {
        className: "seafile-editor-outline"
      }, headerList && headerList.length > 0 ? headerList.map(function (node, index) {
        return /*#__PURE__*/React.createElement(OutlineItem, {
          key: index,
          editor: _this3.props.editor,
          activeTitleIndex: _this3.props.activeTitleIndex,
          node: node,
          index: index
        });
      }) : this.props.isViewer ? null : /*#__PURE__*/React.createElement("div", {
        className: "size-panel-no-content"
      }, this.props.t('no_out_line')));
    }
  }]);

  return OutlineView;
}(React.PureComponent);

export default withTranslation('seafile-editor')(OutlineView);